module.exports = "/_next/static/images/careerImage-b9e06b311c0eeb389b8ba233a188a046.jpg.webp";